/* eslint-disable @typescript-eslint/no-explicit-any */
import { CommonModule, DatePipe } from '@angular/common';
import { APP_INITIALIZER, ModuleWithProviders, NgModule, isDevMode } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { ServiceWorkerModule } from '@angular/service-worker';
import { UserStateModule } from '@elio/emanager-front/auth/state';
import { ElioMessagingPushModule } from '@elio/emanager-front/push-messaging/firebase-push';
import { MessagingSubscriptionModule } from '@elio/emanager-front/push-messaging/subscription';
import {
  CustomRouterStateSerializer,
  RouterSelectors,
  RouterUrlService,
} from '@elio/emanager-front/shared/data-access/router';
import { elioArrowIcon } from '@elio/icon/arrow';
import { elioArrowUpIcon } from '@elio/icon/arrow_up';
import { elioCrossIcon } from '@elio/icon/cross';
import { elioCuttedCircleIcon } from '@elio/icon/cutted_circle';
import { landingPageIcons } from '@elio/icon/landingPage';
import { ElioSvgIconsModule } from '@elio/shared/icon-utils';
import { DefaultLoggerService, LoggerService, ProdLoggerService } from '@elio/shared/tools/logger';
import { EffectsModule } from '@ngrx/effects';
import { RouterStateSerializer, StoreRouterConnectingModule, routerReducer } from '@ngrx/router-store';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { EmanagerFrontShellComponent } from './emanager-front-shell.component';
import { routes } from './emanager-front-shell.routes';
import { httpInterceptorProviders } from './interceptors-provider';
import { OptInPreloadStrategy } from './preload.service';

const rootReducers = {
  [RouterSelectors.ROUTER_KEY]: routerReducer,
};

export const initNavigationListener = (routerUrlService: RouterUrlService) => () => routerUrlService.listenRoutes();

const extModules: ModuleWithProviders<any>[] = [];

if (isDevMode()) {
  extModules.push(
    StoreDevtoolsModule.instrument({
      maxAge: 25,
      logOnly: true,
    })
  );
  extModules.push(ServiceWorkerModule.register('firebase-messaging-sw.js'));
} else {
  extModules.push(
    ServiceWorkerModule.register('root-service-worker.js', {
      registrationStrategy: 'registerImmediately',
    })
  );
}

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forRoot(routes, {
      preloadingStrategy: OptInPreloadStrategy,
    }),
    StoreModule.forRoot(rootReducers),
    EffectsModule.forRoot(),
    MessagingSubscriptionModule,
    UserStateModule,
    StoreRouterConnectingModule.forRoot(),
    ElioSvgIconsModule.forRoot({
      icons: [...landingPageIcons, elioCuttedCircleIcon, elioCrossIcon, elioArrowUpIcon, elioArrowIcon],
    }),
    ElioMessagingPushModule,
    MatDialogModule,
    ...extModules,
  ],
  exports: [RouterModule],
  providers: [
    httpInterceptorProviders,
    {
      provide: RouterStateSerializer,
      useClass: CustomRouterStateSerializer,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initNavigationListener,
      deps: [RouterUrlService],
      multi: true,
    },
    { provide: LoggerService, useClass: isDevMode() ? DefaultLoggerService : ProdLoggerService },
    DatePipe,
  ],
  declarations: [EmanagerFrontShellComponent],
})
export class EmanagerFrontShellModule {}
